<template>
  <div id="messageMrg">
    <TopList :navList="navList" @setType="setType"></TopList>
    <All v-if="type === 0 || type === 1"></All>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import All from "./components/all";

export default {
  name: "index",
  components: {
    TopList,
    All,
  },
  data() {
    return {
      type: 0,
      navList: ["全部", "会议"],
    };
  },
  methods: {
    setType(e) {
      this.type = e;
    },
  },
};
</script>

<style lang="scss" scoped>
#messageMrg {
  width: 1200px;
  // height: 300px;
  //background: pink;
}
</style>
